
class CustomizerOrchestrator {
  constructor() {
    this.file360Url =
      'https://cdn.shopify.com/3d/models/ad6266d331dec876/garrafa_anim_V7_web.glb';

    this.COLORS = {
      rosa: {
        label: 'Rosa',
        solid: [196, 113, 130],
        body: 'https://cdn.shopify.com/s/files/1/0755/4357/6885/files/cor-garrafa-com-logo-rosa-v2.png?v=1784245402',
        cap: 'https://cdn.shopify.com/s/files/1/0755/4357/6885/files/tampa-uv-rosa.png?v=1783887126',
        variantId: '52371553485109',
      },
      verde: {
        label: 'Verde',
        solid: [93, 125, 104],
        body: 'https://cdn.shopify.com/s/files/1/0755/4357/6885/files/cor-garrafa-com-logo-verde-v2.png?v=1784245949',
        cap: 'https://cdn.shopify.com/s/files/1/0755/4357/6885/files/tampa-uv-verde.png?v=1783887126',
        variantId: '52371553550645',
      },
      branca: {
        label: 'Branca',
        solid: [235, 235, 235],
        body: 'https://cdn.shopify.com/s/files/1/0755/4357/6885/files/cor-garrafa-com-logo-branca-v2.png?v=1784245949',
        cap: 'https://cdn.shopify.com/s/files/1/0755/4357/6885/files/tampa-uv-branca.png?v=1783887126',
        variantId: '52371553517877',
      },
      preta: {
        label: 'Preta',
        solid: [31, 31, 31],
        body: 'https://cdn.shopify.com/s/files/1/0755/4357/6885/files/cor-garrafa-com-logo-preta-v2.png?v=1784245949',
        cap: 'https://cdn.shopify.com/s/files/1/0755/4357/6885/files/tampa-uv-preta.png?v=1783887126',
        variantId: '52371553583413',
      },
    };

    this.ARTS = [
      {
        key: 'sakura-tree',
        name: 'Sakura Tree',
        sku: '4413',
        url: 'https://cdn.shopify.com/s/files/1/0755/4357/6885/files/4413---Sakura-Tree-Full-360-v2.png?v=1785188135',
        previewUrl:
          'https://cdn.shopify.com/s/files/1/0755/4357/6885/files/4413---Sakura-Tree-Full-360_eb9b5178-dddd-497e-9dfd-f11e0d292534.png?v=1785188496',
        align: null,
        category: {
          key: 'padrao',
          name: 'Padrão',
        },
        type: 'full',
        textCompatible: 'incompatible',
        colorsNotAllowed: [],
      },
      {
        key: 'sweet-love',
        name: 'Sweet Love',
        sku: '4418',
        url: 'https://cdn.shopify.com/s/files/1/0755/4357/6885/files/4418---Sweet-Love-Full-360-v2.png?v=1785188134',
        previewUrl:
          'https://cdn.shopify.com/s/files/1/0755/4357/6885/files/4418---Sweet-Love-Full-360_2c97d9df-72c8-4d86-9d41-6b2c2203f44d.png?v=1785188496',
        align: null,
        category: {
          key: 'padrao',
          name: 'Padrão',
        },
        type: 'full',
        textCompatible: 'incompatible',
        colorsNotAllowed: [],
      },
      {
        key: 'nossa-senhora-de-fatima',
        name: 'Nossa Senhora de Fátima',
        sku: '4433',
        url: 'https://cdn.shopify.com/s/files/1/0755/4357/6885/files/4433---Nossa-Senhora-de-Fatima-Full-360_-v2.png?v=1785188133',
        previewUrl:
          'https://cdn.shopify.com/s/files/1/0755/4357/6885/files/4433---Nossa-Senhora-de-Fatima-Full-360_a892b67e-8b23-441f-beb8-7a95973b4408.png?v=1785188496',
        align: null,
        category: {
          key: 'padrao',
          name: 'Padrão',
        },
        type: 'full',
        textCompatible: 'incompatible',
        colorsNotAllowed: [],
      },
      {
        key: 'sun-moon',
        name: 'Sun & Moon',
        sku: '4439',
        url: 'https://cdn.shopify.com/s/files/1/0755/4357/6885/files/4439---Sun-_-Moon-Full-360-v2.png?v=1785188135',
        previewUrl:
          'https://cdn.shopify.com/s/files/1/0755/4357/6885/files/4439---Sun-_-Moon-Full-360_d7583cee-2fbb-468b-ae26-9830ba84f10e.png?v=1785188496',
        align: null,
        category: {
          key: 'padrao',
          name: 'Padrão',
        },
        type: 'full',
        textCompatible: 'incompatible',
        colorsNotAllowed: [],
      },
      {
        key: 'onca-print',
        name: 'Onca Print',
        sku: '4424',
        url: 'https://cdn.shopify.com/s/files/1/0755/4357/6885/files/4424---Onca-Print-Full-360-v2.png?v=1785188133',
        previewUrl:
          'https://cdn.shopify.com/s/files/1/0755/4357/6885/files/4424---Onca-Print-Full-360_d75f786d-5650-4197-ad6d-4dee98fb33f5.png?v=1785188496',
        align: null,
        category: {
          key: 'padrao',
          name: 'Padrão',
        },
        type: 'full',
        textCompatible: 'incompatible',
        colorsNotAllowed: ['preta'],
      },
      {
        key: 'monograma-florido',
        name: 'Monograma Florido',
        sku: '4414',
        url: 'https://cdn.shopify.com/s/files/1/0755/4357/6885/files/4414---Monograma-Florido-Full-360-v2.png?v=1785188135',
        previewUrl:
          'https://cdn.shopify.com/s/files/1/0755/4357/6885/files/4414---Monograma-Florido-Full-360_79fef883-3d59-49f0-9264-5b4a86eaaf85.png?v=1785188496',
        align: null,
        category: {
          key: 'padrao',
          name: 'Padrão',
        },
        type: 'full',
        textCompatible: 'custom_01',
        colorsNotAllowed: [],
      },
      {
        key: 'butterflies',
        name: 'Butterflies',
        sku: '4410',
        url: 'https://cdn.shopify.com/s/files/1/0755/4357/6885/files/4410---Butterflies-Full-360-v2.png?v=1785188136',
        previewUrl:
          'https://cdn.shopify.com/s/files/1/0755/4357/6885/files/4410---Butterflies-Full-360_af1d0b0c-aece-4138-bc80-b022a3d42ec9.png?v=1785188496',
        align: null,
        category: {
          key: 'padrao',
          name: 'Padrão',
        },
        type: 'full',
        textCompatible: 'incompatible',
        colorsNotAllowed: [],
      },
      {
        key: 'esoteric-eye',
        name: 'Esoteric Eye',
        sku: '4412',
        url: 'https://cdn.shopify.com/s/files/1/0755/4357/6885/files/4412---Esoteric-Eye-Full-360-v2.png?v=1785188136',
        previewUrl:
          'https://cdn.shopify.com/s/files/1/0755/4357/6885/files/4412---Esoteric-Eye-Full-360_8a6ef0cc-9082-48f3-87ad-05accb52828e.png?v=1785188496',
        align: null,
        category: {
          key: 'padrao',
          name: 'Padrão',
        },
        type: 'full',
        textCompatible: 'incompatible',
        colorsNotAllowed: [],
      },
      {
        key: 'number-stripes-01',
        name: 'Number Stripes 01',
        sku: '4394',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/number-stripes-preta----4394---110x496.png`,
        align: 'center',
        category: {
          key: 'brasil',
          name: 'Brasil',
        },
        type: 'icon',
        textCompatible: 'incompatible',
        colorsNotAllowed: [],
      },
      {
        key: 'number-stripes-02',
        name: 'Number Stripes 02',
        sku: '4136',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/number-stripe----4136---110x496.png`,
        align: 'center',
        category: {
          key: 'brasil',
          name: 'Brasil',
        },
        type: 'icon',
        textCompatible: 'incompatible',
        colorsNotAllowed: [],
      },
      {
        key: 'made-in-brasil',
        name: 'Made in Brasil',
        sku: '4134',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/made-in-brasil----4134---114x480.png`,
        align: 'center',
        category: {
          key: 'brasil',
          name: 'Brasil',
        },
        type: 'icon',
        textCompatible: 'incompatible',
        colorsNotAllowed: [],
      },
      {
        key: 'brazilian-name',
        name: 'Brazilian Name',
        sku: '4135',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/brazilian-name---4135---96x96.png`,
        align: 'top',
        category: {
          key: 'brasil',
          name: 'Brasil',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorsNotAllowed: [],
      },
      {
        key: 'brazilian-flag',
        name: 'Brazilian Flag',
        sku: '4355',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/brazilian-flag---4355---125x82.png`,
        align: 'top',
        category: {
          key: 'brasil',
          name: 'Brasil',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorsNotAllowed: [],
      },
      {
        key: 'torcedor-bahia',
        name: 'Torcedor Bahia',
        sku: '4001',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/torcedor-do-bahia-versão-1---4001---109x130px.png`,
        align: 'top',
        category: {
          key: 'futebol',
          name: 'Futebol',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorsNotAllowed: [],
      },
      {
        key: 'torcedor-vitória',
        name: 'Torcedor Vitória',
        sku: '3998',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/Torcedor-do-Vitória----3998---109x130px.png`,
        align: 'top',
        category: {
          key: 'futebol',
          name: 'Futebol',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorsNotAllowed: [],
      },
      {
        key: 'beating-heart',
        name: 'Beating Heart',
        sku: '4055',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/Beating-Heart----4055---118x90px.png`,
        align: 'top',
        category: {
          key: 'padrao',
          name: 'Padrão',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorsNotAllowed: ['preta'],
      },
      {
        key: 'heart-name',
        name: 'Heart Name',
        sku: '4051',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/Heart-Name----4051---109x130px.png`,
        align: 'top',
        category: {
          key: 'padrao',
          name: 'Padrão',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorsNotAllowed: ['branca'],
      },
      {
        key: 'kettlebell',
        name: 'Kettlebell',
        sku: '4048',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/Kettlebell----4048---100x122px.png`,
        align: 'top',
        category: {
          key: 'musculacao',
          name: 'Musculação',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorsNotAllowed: ['branca'],
      },
      {
        key: 'futvolei-masculino',
        name: 'Futvolei Masculino',
        sku: '4050',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/Futvôlei-masculino---4050---96x96px.png`,
        align: 'top',
        category: {
          key: 'esportes',
          name: 'Esportes',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorsNotAllowed: ['branca'],
      },
      {
        key: 'blessed',
        name: 'Blessed',
        sku: '3992',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/blessed---3992---110x170px.png`,
        align: 'top',
        category: {
          key: 'padrao',
          name: 'Padrão',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorsNotAllowed: [],
      },
      {
        key: 'butterfly-harmony',
        name: 'Butterfly Harmony',
        sku: '4052',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/Butterfly-Harmony----4052---125x82px.png`,
        align: 'top',
        category: {
          key: 'padrao',
          name: 'Padrão',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorsNotAllowed: [],
      },
      {
        key: 'butterfly-name',
        name: 'Butterfly Name',
        sku: '4049',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/Butterfly-Name-----4049---125x82px.png`,
        align: 'top',
        category: {
          key: 'padrao',
          name: 'Padrão',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorsNotAllowed: ['branca'],
      },
      {
        key: 'futvolei-feminino',
        name: 'Futvolei Feminino',
        sku: '4050',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/Futvôlei-feminino---4050---96x96px.png`,
        align: 'top',
        category: {
          key: 'esportes',
          name: 'Esportes',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorsNotAllowed: ['branca'],
      },
      {
        key: 'laco-de-cetim',
        name: 'Laco De Cetim',
        sku: '4046',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/Laço-de-Cetim----4046---109x130px.png`,
        align: 'top',
        category: {
          key: 'padrao',
          name: 'Padrão',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorsNotAllowed: [],
      },
      {
        key: 'martial-arts',
        name: 'Martial Arts',
        sku: '4053',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/Martial-Arts-----4053---123x56px.png`,
        align: 'top',
        category: {
          key: 'artes-marciais',
          name: 'Artes Marciais',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorsNotAllowed: [],
      },
      {
        key: 'martial-arts-azul',
        name: 'Martial Arts Azul',
        sku: '4053',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/Martial-Arts-azul-----4053---123x56px.png`,
        align: 'top',
        category: {
          key: 'artes-marciais',
          name: 'Artes Marciais',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorsNotAllowed: [],
      },
      {
        key: 'martial-arts-branca',
        name: 'Martial Arts Branca',
        sku: '4053',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/Martial-Arts-branca----4053---123x56px.png`,
        align: 'top',
        category: {
          key: 'artes-marciais',
          name: 'Artes Marciais',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorsNotAllowed: [],
      },
      {
        key: 'martial-arts-marrom',
        name: 'Martial Arts Marrom',
        sku: '4053',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/Martial-Arts-marrom-----4053---123x56px.png`,
        align: 'top',
        category: {
          key: 'artes-marciais',
          name: 'Artes Marciais',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorsNotAllowed: [],
      },
      {
        key: 'martial-arts-preto',
        name: 'Martial Arts Preto',
        sku: '4053',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/Martial-Arts-preto-----4053---123x56px.png`,
        align: 'top',
        category: {
          key: 'artes-marciais',
          name: 'Artes Marciais',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorsNotAllowed: [],
      },
      {
        key: 'martial-arts-roxa',
        name: 'Martial Arts Roxa',
        sku: '4053',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/Martial-Arts-roxa-----4053---123x56px.png`,
        align: 'top',
        category: {
          key: 'artes-marciais',
          name: 'Artes Marciais',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorsNotAllowed: [],
      },
      {
        key: 'name-and-flower',
        name: 'Name And Flower',
        sku: '3991',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/Name-and-Flower---3991---124x136px.png`,
        align: 'top',
        category: {
          key: 'padrao',
          name: 'Padrão',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorsNotAllowed: [],
      },
      {
        key: 'pole-position-name',
        name: 'Pole Position Name',
        sku: '3995',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/pole-position-name---3995---109x130px.png`,
        align: 'top',
        category: {
          key: 'carros',
          name: 'Carros',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorsNotAllowed: ['branca'],
      },
      {
        key: 'xp-naming',
        name: 'XP Naming',
        sku: '4105',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/xp-naming---4105--115x118px.png`,
        align: 'top',
        category: {
          key: 'xp-trading',
          name: 'XP Trading',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorsNotAllowed: ['branca'],
      },
      {
        key: 'daily-profit',
        name: 'Daily Profit',
        sku: '4113',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/Daily-Profit---4113--125x180.png`,
        align: 'center',
        category: {
          key: 'xp-trading',
          name: 'XP Trading',
        },
        type: 'icon',
        textCompatible: 'incompatible',
        colorsNotAllowed: ['branca'],
      },
      {
        key: 'day-trade-horizon',
        name: 'Day Trade Horizon',
        sku: '4112',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/Day-Trade-Horizon---4112--114x387.png`,
        align: 'center',
        category: {
          key: 'xp-trading',
          name: 'XP Trading',
        },
        type: 'icon',
        textCompatible: 'incompatible',
        colorsNotAllowed: ['branca'],
      },
      {
        key: 'inside-the-trade',
        name: 'Inside the Trade',
        sku: '4111',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/Inside-the-Trade---4111--110x496.png`,
        align: 'center',
        category: {
          key: 'xp-trading',
          name: 'XP Trading',
        },
        type: 'icon',
        textCompatible: 'incompatible',
        colorsNotAllowed: [],
      },
      {
        key: 'escudo-atletico-mineiro',
        name: 'Escudo Atlético Mineiro',
        sku: '3958',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/escudo-atletico-mineiro--3958--100x140px.png`,
        align: 'top',
        category: {
          key: 'futebol',
          name: 'Futebol',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorsNotAllowed: [],
      },
      {
        key: 'escudo-ceara',
        name: 'Escudo Ceará',
        sku: '3953',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/escudo-ceara--3953--118x128px.png`,
        align: 'top',
        category: {
          key: 'futebol',
          name: 'Futebol',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorsNotAllowed: [],
      },
      {
        key: 'escudo-cruzeiro',
        name: 'Escudo Cruzeiro',
        sku: '4075',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/escudo-cruzeiro--4075--120x120px.png`,
        align: 'top',
        category: {
          key: 'futebol',
          name: 'Futebol',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorDeviceIncompatible: ['Preto'],
        colorsNotAllowed: ['preta'],
      },
      {
        key: 'escudo-fortaleza',
        name: 'Escudo Fortaleza',
        sku: '3898',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/escudo-fortaleza---3898--100x128px.png`,
        align: 'top',
        category: {
          key: 'futebol',
          name: 'Futebol',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorDeviceIncompatible: ['Preto'],
        colorsNotAllowed: ['preta'],
      },
      {
        key: 'escudo-fortaleza-azul',
        name: 'Escudo Fortaleza Azul',
        sku: '4085',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/escudo-fortaleza---4085--100x128px.png`,
        align: 'top',
        category: {
          key: 'futebol',
          name: 'Futebol',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorDeviceIncompatible: ['Preto'],
        colorsNotAllowed: ['preta'],
      },
      {
        key: 'escudo-goias',
        name: 'Escudo Goiás',
        sku: '3909',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/escudo-goias--3909--120x120px.png`,
        align: 'top',
        category: {
          key: 'futebol',
          name: 'Futebol',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorsNotAllowed: [],
      },
      {
        key: 'escudo-paysandu',
        name: 'Escudo Paysandu',
        sku: '3986',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/escudo-paysandu--3986--100x128px.png`,
        align: 'top',
        category: {
          key: 'futebol',
          name: 'Futebol',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorsNotAllowed: [],
      },
      {
        key: 'escudo-sport-recife',
        name: 'Escudo Sport Recife',
        sku: '3899',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/escudo-sport-recife --3899--100x128px.png`,
        align: 'top',
        category: {
          key: 'futebol',
          name: 'Futebol',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorsNotAllowed: [],
      },
      {
        key: 'escudo-vitoria',
        name: 'Escudo Vitória',
        sku: '3900',
        url: `https://cdn.vxcaseloja.com/garrafa/estampas/escudo-vitoria--3900-100x128px.png`,
        align: 'top',
        category: {
          key: 'futebol',
          name: 'Futebol',
        },
        type: 'icon',
        textCompatible: 'name_or_initial',
        colorsNotAllowed: [],
      },
    ];

    this.FONTS = [
      {
        key: 'planet-kosmos',
        name: 'Planet Kosmos',
        size: {
          upTo5: 88,
          upTo10: 50,
          above10: 32,
          twoCharsLayoutInitials: 74,
        },
        weight: 'regular',
        application: 'lowercase',
        applyLayoutInitials: true,
      },
      {
        key: 'gilroy',
        name: 'Gilroy',
        size: {
          upTo5: 90,
          upTo10: 60,
          above10: 38,
          twoCharsLayoutInitials: 90,
        },
        weight: 'bold',
        application: 'uppercase',
        applyLayoutInitials: true,
      },
      {
        key: 'clash-display',
        name: 'Clash Display',
        size: {
          upTo5: 108,
          upTo10: 55,
          above10: 38,
          twoCharsLayoutInitials: 53,
        },
        weight: 'bold',
        application: 'uppercase',
        applyLayoutInitials: true,
      },
      {
        key: 'bengoda',
        name: 'Bengoda',
        size: {
          upTo5: 85,
          upTo10: 80,
          above10: 54,
          twoCharsLayoutInitials: 0,
        },
        weight: 'regular',
        application: 'titlecase',
        applyLayoutInitials: false,
      },
      {
        key: 'tusker',
        name: 'Tusker',
        size: {
          upTo5: 110,
          upTo10: 80,
          above10: 56,
          twoCharsLayoutInitials: 85,
        },
        weight: 'semibold',
        application: 'uppercase',
        applyLayoutInitials: true,
      },
      {
        key: 'adelia',
        name: 'Adelia',
        size: {
          upTo5: 58,
          upTo10: 56,
          above10: 38,
          twoCharsLayoutInitials: 0,
        },
        weight: 'regular',
        application: 'lowercase',
        applyLayoutInitials: false,
      },
    ];

    this.FONT_CUSTOMS = {
      custom_01: {
        initial: {
          key: 'paris-pro-bold',
          name: 'Paris Pro Bold',
          size: 110,
          weight: 'semibold',
          application: 'uppercase',
        },
        name: {
          key: 'reinata',
          name: 'Reinata',
          size: {
            upTo5: 52,
            upTo10: 50,
            above10: 40,
          },
          weight: 'regular',
          application: 'titlecase',
        },
        scale: 1.95,
        initialScale: 1.6,
        centerY: 0.24,
        nameOffsetY: 0,
        initialOffsetY: 18,
        initialAlpha: 0.55,
        colorUi: 'dual',
      },
    };

    this.MAX_LENGTH_FULLNAME = 15;
    this.MAX_LENGTH_INITIALS = 2;

    this.BODY_MATERIAL = 'Material';
    this.CAP_LOGO_MATERIAL = 'Material.001';
    this.CAP_SOLID_MATERIALS = [
      'Material.007',
      'Material.003',
      'Material.006',
      'Material.008',
      'Material.009',
      'Material.005',
      'Material.004',
    ];

    this.BODY_TEXT_TOP = 0.1;
    this.BODY_TEXT_BOTTOM = 0.38;
    this.BODY_ICON_TOP = 0.055;
    this.BODY_ICON_BOTTOM = this.BODY_TEXT_BOTTOM;
    this.BODY_UV_ANISO = (2 * Math.PI * 4.286 * 0.4669) / 20.819;
    this.DESIGN_STAGE = 1000;
    this.BODY_BASE_CACHE_PREFIX = 'body:v9';

    this.FONT_ASSET_BASE_URL =
      'https://cdn.vxcase.com.br/landing-pages/print-my-case-fonts';
    this.TEXT_INPUT_DEBOUNCE_MS = 120;

    this.SHOPIFY_STORE_URL = 'https://www.vxcase.com.br';
    this.PRINT_API_URL = 'https://print-storefront-api.vxcase.com.br';
    this.DEFAULT_PRODUCT_SKU = '4084';
    this.PRODUCT_NAME =
      'Garrafa Térmica 950ml com Suporte Magsafe - Mag Bottle VX Case';
    this.FINISH_PRICE = {
      pix: 'R$ 284,05',
      full: 'R$ 299,00',
      installment: 'R$ 74,75',
      bonus: 'R$ 14,95',
    };
    this.QR_CODE_API_URL = 'https://api.qrserver.com/v1/create-qr-code/';
    this.TEXT_COLOR_PRESETS = [
      '#1E90FF',
      '#FF1493',
      '#FFD700',
      '#000000',
      '#FFFFFF',
    ];

    this.SIDEBAR_SHEET_DEFAULT = 42;
    this.SIDEBAR_SHEET_MAX = 90;
    this.MOBILE_SHEET_MEDIA_QUERY = '(max-width: 989px)';

    this.PREVIEW_ZOOM_IN_FACTOR = 0.2;
    this.PREVIEW_ZOOM_OUT_FACTOR = -0.2;
    this.FINISH_PREVIEW_EXPORT_SIZE = 1000;

    this.initializeDomReferences();

    this.selectionState = new window.CustomizerSelectionState(this);
    this.bottleSceneController = new window.BottleSceneController(this);
    this.bodyTextureComposer = new window.BodyTextureComposer(this);
    this.artsPanelController = new window.ArtsPanelController(this);
    this.bottleColorPickerController = new window.BottleColorPickerController(this);
    this.textCustomizationController = new window.TextCustomizationController(this);
    this.stepNavigationController = new window.StepNavigationController(this);
    this.finishCheckoutController = new window.FinishCheckoutController(this);
    this.sidebarSheetController = new window.SidebarSheetController(this);
    this.shopifyCartController = new window.ShopifyCartController(this);

    this.bootstrapControllers();
  }

  isCompactLayout(mediaQuery) {
    const modal = this.dom && this.dom.modal;
    if (modal && modal.classList.contains('modal-customizer-my-bottle--page')) {
      return true;
    }
    if (typeof window === 'undefined' || !mediaQuery) return false;
    return window.matchMedia(mediaQuery).matches;
  }

  initializeDomReferences() {
    const modal =
      document.querySelector('.modal-customizer-my-bottle--page') ||
      document.querySelector('.modal-customizer-my-bottle');
    const customizerMain = modal.querySelector('.customizer-main');

    this.dom = {
      modal,
      customizerMain,
      deviceContent: modal.querySelector('.modal__content .customizer-main'),
      loadingElement: customizerMain.querySelector('.customizer-loading'),
      colorButtons: customizerMain.querySelectorAll('.color-swatch'),
      modalWrapper: modal.querySelector('.modal__wrapper'),
      modalContent: modal.querySelector('.modal__content'),
      customizerSidebar: modal.querySelector('.customizer-sidebar'),
      sidebarSheetHandle: modal.querySelector('#sidebar-sheet-handle'),
      stepContent: modal.querySelector(
        '.customizer-sidebar .step-arts .step-content',
      ),
      styleButtons: modal.querySelectorAll('[data-style]'),
      methodButtons: modal.querySelectorAll('[data-method]'),
      methodSection: modal.querySelector('#method-section'),
      footerInkNote: modal.querySelector('#footer-ink-note'),
      contentStepSubtitle: modal.querySelector('#content-step-subtitle'),
      contentBlocks: modal.querySelectorAll('[data-content-block]'),
      contentTextLabel: modal.querySelector('#content-text-label'),
      contentTextCounter: modal.querySelector('#content-text-counter'),
      inkColorName: modal.querySelector('#ink-color-name'),
      laserColorSection: modal.querySelector('#laser-color-section'),
      laserColorName: modal.querySelector('#laser-color-name'),
      laserColorButtons: modal.querySelectorAll('[data-laser-color]'),
      fontElCarousel: modal.querySelector('#font-carousel'),
      textsLayoutSection: modal.querySelector('#texts-layout-section'),
      textsFontSection: modal.querySelector('#texts-font-section'),
      textsColorSectionDefault: modal.querySelector(
        '#texts-color-section-default',
      ),
      textsColorSectionDual: modal.querySelector('#texts-color-section-dual'),
      textInput: modal.querySelector('#name-customizer-device'),
      textLayoutButtons: modal.querySelectorAll(
        '.options-device-layout-tag[data-layout]',
      ),
      navSteps: modal.querySelectorAll('.modal__header .steps .step'),
      contentSteps: modal.querySelectorAll(
        '.customizer-sidebar .steps [data-content-step]',
      ),
      btnNextStep: modal.querySelector('#btn-next-step'),
      btnBackStep: modal.querySelector('#btn-back-step'),
      finishAddCartBtn: modal.querySelector('#finish-add-cart'),
      finishCheckoutQrBtn: modal.querySelector('#finish-checkout-qr'),
      checkoutQrOverlay: modal.querySelector('#checkout-qr-overlay'),
      checkoutQrImage: modal.querySelector('#checkout-qr-image'),
      checkoutQrLink: modal.querySelector('#checkout-qr-link'),
      checkoutQrCloseBtn: modal.querySelector('#checkout-qr-close'),
      finishProductColorEl: modal.querySelector('#finish-product-color'),
      finishArtRowEl: modal.querySelector('#finish-art-row'),
      finishArtNameEl: modal.querySelector('#finish-art-name'),
      finishTextSummaryEl: modal.querySelector('#finish-text-summary'),
      finishTextValueEl: modal.querySelector('#finish-text-value'),
      finishTextFontEl: modal.querySelector('#finish-text-font'),
      finishTextColorEl: modal.querySelector('#finish-text-color'),
      finishTextColorSwatchEl: modal.querySelector('#finish-text-color-swatch'),
      finishTextColorRowEl: modal.querySelector('#finish-text-color-row'),
      finishTextColorInitialRowEl: modal.querySelector(
        '#finish-text-color-initial-row',
      ),
      finishTextColorInitialEl: modal.querySelector(
        '#finish-text-color-initial',
      ),
      finishTextColorInitialSwatchEl: modal.querySelector(
        '#finish-text-color-initial-swatch',
      ),
      finishTextColorNameRowEl: modal.querySelector(
        '#finish-text-color-name-row',
      ),
      finishTextColorNameEl: modal.querySelector('#finish-text-color-name'),
      finishTextColorNameSwatchEl: modal.querySelector(
        '#finish-text-color-name-swatch',
      ),
      finishQtyInput: modal.querySelector('#finish-qty-input'),
      finishQtyMinus: modal.querySelector('#finish-qty-minus'),
      finishQtyPlus: modal.querySelector('#finish-qty-plus'),
      reviewStyleEl: modal.querySelector('#review-style'),
      reviewMethodEl: modal.querySelector('#review-method'),
      reviewArtRowEl: modal.querySelector('#review-art-row'),
      reviewArtEl: modal.querySelector('#review-art'),
      reviewTextRowEl: modal.querySelector('#review-text-row'),
      reviewTextLabelEl: modal.querySelector('#review-text-label'),
      reviewTextEl: modal.querySelector('#review-text'),
      reviewLayoutRowEl: modal.querySelector('#review-layout-row'),
      reviewLayoutEl: modal.querySelector('#review-layout'),
      reviewFontRowEl: modal.querySelector('#review-font-row'),
      reviewFontEl: modal.querySelector('#review-font'),
      reviewColorRowEl: modal.querySelector('#review-color-row'),
      reviewColorLabelEl: modal.querySelector('#review-color-label'),
      reviewColorEl: modal.querySelector('#review-color'),
      reviewBottleColorEl: modal.querySelector('#review-bottle-color'),
      reviewAccepted: modal.querySelector('#review-accepted'),
    };
  }

  bootstrapControllers() {
    this.stepNavigationController.initialize();
    this.bottleColorPickerController.initialize();
    this.textCustomizationController.initializeFontCarousel();
    this.textCustomizationController.initializeTextControls();
    this.finishCheckoutController.initialize();
    this.sidebarSheetController.initialize();
  }

  getFontCustomConfig(key) {
    if (!key) return null;
    return this.FONT_CUSTOMS[key] || null;
  }

  isFontCustomArt(art) {
    return Boolean(this.getFontCustomConfig(art?.textCompatible));
  }

  usesDualTextColors(art = this.selectionState.getSelectedArt()) {
    const config = this.getFontCustomConfig(art?.textCompatible);
    return config?.colorUi === 'dual';
  }

  artAllowsText(art) {
    if (this.selectionState?.style === 'textprint') return true;
    if (!art) return true;
    return (
      art.textCompatible === 'name_or_initial' || this.isFontCustomArt(art)
    );
  }

  openCustomizerModal() {
    this.bottleSceneController.initializeSceneOnFirstOpen();
  }

  closeCustomizerModal() {
    this.setPreviewExpanded(false);
    this.dom.modal.classList.remove('active');
    document.body.style.overflow = 'auto';
  }

  setPreviewExpanded(expanded) {
    this.bottleSceneController.setPreviewExpanded(expanded);
  }

  zoomPreview(factor) {
    this.bottleSceneController.zoomPreview(factor);
  }
}

window.CustomizerOrchestrator = CustomizerOrchestrator;
